<script>
import { WALLET_EMPTY_MESSAGE } from '@modules/consolidator/constants/Text'
import { chartHasNoData } from '@modules/consolidator/utils/chart-has-no-data/chart-has-no-data'
import FeedbackWrapper from '@modules/global/components/feedback-wrapper/feedback-wrapper.vue'
import PatrimonioChart from '@modules/consolidator/components/patrimonio-chart/patrimonio-chart.vue'

export default {
  name: 'EvolucaoPatrimonial',
  components: {
    FeedbackWrapper,
    PatrimonioChart,
  },
  props: {
    hideVerMais: { type: Boolean, default: false },
    data: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    investmentType: {
      type: String,
      default: '',
    },
    emptyMessage: {
      type: String,
      default: WALLET_EMPTY_MESSAGE,
    },
  },
  computed: {
    hasNoData() {
      return chartHasNoData(this.data)
    },
  },
  methods: {
    openEvolucaoPatrimonial() {
      this.$router.push({
        name: 'carteira.evolucao',
      })
    },
  },
}
</script>

<template>
  <div
    class="evolucao-patrimonial az-card-bordered"
    :class="{ 'evolucao-patrimonial--loading': loading }"
  >
    <div v-if="!loading" class="evolucao-patrimonial__header">
      <div
        class="evolucao-patrimonial__title az-ds-card-title"
      >
        Evolução Patrimonial
      </div>
      <div class="evolucao-patrimonial__actions">
        <div class="evolucao-patrimonial__actions-left">
          <slot name="actions-left"></slot>
        </div>

        <div class="evolucao-patrimonial__actions-right">
          <div
            v-if="!hideVerMais"
            class="evolucao-patrimonial__action-patrimonio"
          >
            <BaseButton secondary text sm @click="openEvolucaoPatrimonial">
              <icon-svg name="mdi-eye" :size="16" color="primary" />
              Ver mais
            </BaseButton>
          </div>
          <slot name="actions-right"></slot>
        </div>
      </div>
    </div>

    <FeedbackWrapper
      :loading="loading"
      :noData="hasNoData"
      :message="emptyMessage"
    >
      <div class="evolucao-patrimonial__content">
        <PatrimonioChart :data="data" :investmentType="investmentType" />
      </div>
    </FeedbackWrapper>
  </div>
</template>

<style lang="sass">
.evolucao-patrimonial
  padding-bottom: 32px

  &--loading
    padding: 0 !important

  @mixin flex-center($gap: 16px)
    display: flex
    align-items: center
    gap: $gap

  &__header
    @include flex-center(32px)
    align-items: flex-start
    margin-bottom: 16px
    flex-wrap: wrap
    justify-content: space-between

  &__actions
    @include flex-center(16px)
    justify-content: space-between
    flex: 1 1 auto
    min-width: 280px

    &-left
      @include flex-center
      flex: 1 1 auto
      min-width: 0

    &-right
      @include flex-center(2px)
      justify-content: space-between
      min-width: 260px

  &__title
    min-width: 180px

  &__action-patrimonio
    button
      min-width: unset !important

  &__content
    min-height: 450px
</style>
